import React from 'react';
import { motion } from 'framer-motion';
export function BodyContent() {
  return <section className="py-12 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-11">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-center" data-id="element-12">
        {/* Left Column - Text */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="md:col-span-7 space-y-8" data-id="element-13">
          <h3 className="text-3xl font-serif text-charcoal leading-snug" data-id="element-14">
            El declive silencioso después de los 40
          </h3>
          <p className="text-lg font-sans font-light text-charcoal-light leading-relaxed" data-id="element-15">
            Los estudios clínicos son claros: después de los 40 años, la
            densidad muscular facial{' '}
            <span className="font-medium text-charcoal" data-id="element-16">
              cae un 1% cada año
            </span>{' '}
            si no se estimula adecuadamente. La gravedad no es la única culpable
            de la flacidez; es la pérdida de masa muscular la que hace que la
            piel pierda su anclaje natural.
          </p>
          <p className="text-lg font-sans font-light text-charcoal-light leading-relaxed" data-id="element-17">
            Aquí es donde entra la{' '}
            <strong className="font-medium text-charcoal" data-id="element-18">Yoga Facial</strong>.
            Una alternativa científica, rigurosa y no invasiva a las inyecciones
            de Botox y los rellenos dérmicos (fillers).
          </p>
        </motion.div>

        {/* Right Column - Highlight Box */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="md:col-span-5 bg-white p-8 shadow-sm border border-gold/10 relative" data-id="element-19">
          <div className="absolute -left-4 top-8 w-8 h-px bg-gold" data-id="element-20"></div>
          <h4 className="font-serif italic text-xl text-gold-dark mb-4" data-id="element-21">
            El secreto silenciado
          </h4>
          <p className="font-sans text-charcoal leading-relaxed" data-id="element-22">
            Este es un descubrimiento médico que ha sido sistemáticamente
            silenciado por las marcas de lujo. Restaurar la{' '}
            <span className="font-medium" data-id="element-23">arquitectura facial</span> mediante{' '}
            <span className="font-medium" data-id="element-24">bio-estimulación</span> natural no
            requiere productos costosos, solo conocimiento anatómico.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="mt-12 text-center" data-id="element-25">
        <hr className="border-gold/30 w-24 mx-auto mb-12" data-id="element-26" />
        <p className="text-xl md:text-2xl font-serif text-charcoal max-w-3xl mx-auto leading-relaxed" data-id="element-27">
          Al reactivar el{' '}
          <span className="italic text-gold-dark" data-id="element-28">drenaje profundo</span> y la
          circulación capilar, el rostro recupera el volumen perdido desde el
          interior hacia el exterior.
        </p>
      </motion.div>
    </section>;
}